import { IDS } from '../../settings-action-id.constants';
import { TAB_SELECT, TAB_SHOW } from '../../../../../common/tabs/tabs.constants'
import * as AccreditationActions from '../../../accreditation.actions';
import * as SettingsActions from "../../settings.actions";
import * as Actions from '../evidence-list.actions';
import {TYPES} from "../../settings-action-type.constants";
import {GRID_RELOAD} from "../../../../../common/grid/grid.constants";
import get from "lodash/get";

export const evidenceImports = {
    /* @ngInject */
    controller: function ($ngRedux, $state, $stateParams, $scope, $rootScope, $filter, NavigationService, AuthService, Notifier, FileActions, DocumentManager) {
        /**
         * @function $onInit
         */
        this.$onInit = async () => {
            this.identifier = IDS.accSettings;
            this.schemeCode = $stateParams.itemCode;
            const navConfig = NavigationService.getConfig($state.$current);
            this.colorName = navConfig.colorName;
            this.icon = navConfig.iconSvg.replace(/(\.\/)/g, '');
            this.parentState = IDS.app_accreditation_scheme_settings_evidence;

            this.unsubscribe = $ngRedux.connect(state => {
                const accSettings = state.accreditation.accSettings;
                return {
                    schemeName: accSettings.frameworkDetails.title,
                    location:   accSettings.evidenceImportsGrid.filter.loc_uuid,
                }
            }, {
                ...AccreditationActions,
                ...FileActions,
                ...SettingsActions,
                ...Actions,
            })(this);

            this.getRegulatoryFrameworkDetails(this.schemeCode).then(scheme => {
                this.fetchEnabledHeadOffices(scheme.id)
            })
        }

        this.onButtonSave = (event) => {
            Notifier.info($filter('translate')('COMMON.NOTIFICATION.PLEASE_WAIT_DOTS'));
            const filePath = event[0].filePath
            this.importEvidenceGroupsFile(filePath, this.schemeCode).then(response => {
                $ngRedux.dispatch({
                    type: GRID_RELOAD,
                    id: IDS.accSettings,
                    path: IDS.evidenceImportsGrid,
                });
                $ngRedux.dispatch({
                    type: GRID_RELOAD,
                    id: IDS.accSettings,
                    path: IDS.evidenceGrid,
                });
            });
        }

        this.onDownloadButton = ({item}) => {
            DocumentManager.downloadFile(item.import_file_uri);
        }

        this.$onDestroy = () => {
            this.unsubscribe();
        }
    },
    template: `
        <tabs-header title="Import History" icon="{{$ctrl.icon}}" color-name="{{$ctrl.colorName}}"></tabs-header>
            <form name="selectCascadeSectionsForm" novalidate layout="row" style="margin-top: 20px">
                <div layout="column" flex>                
                    <div layout-gt-sm="row" flex>
                        <input-select flex
                              label="{{ 'COMMON.FIELD.HEAD_OFFICE' | translate}}"
                              stateDataIdentifier="{{$ctrl.identifier}}"
                              state-data="evidence.enabledHeadOffices"
                              identifier="{{$ctrl.identifier}}.evidenceImportsGrid"
                              state-path="filter.loc_uuid">
                        </input-select>
                    </div>
                </div>
            </form>
        <evidence-imports-grid
            on-download="$ctrl.onDownloadButton($event)">
        </evidence-imports-grid>
        
        <div layout-xs="row" layout-gt-xs="row" flex>
            <form id="importForm" name="$ctrl.importForm" novalidate flex>
                <upload dropzone="true"
                        input-id="uploader"
                        label="Upload Excel File"
                        validate="true"
                        valid-type="xlsx"
                        identifier="evidenceImport"
                        save-button-label="Complete Import"
                        on-save="$ctrl.onButtonSave($event)">
                </upload>
            </form>
        </div>`
}